import { Component,OnInit,ViewChild,ViewEncapsulation,   ElementRef,HostListener ,OnDestroy,AfterViewInit,  NgZone, ViewChildren, QueryList  } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import {PlantillafinService} from '../servicios/plantillafin.service';
import { map, shareReplay } from 'rxjs/operators';
import { CarritoNService } from '../servicios/carrito-n.service';
import { CarroService } from '../servicios/carroservice';
import { ComodatoService } from '../servicios/comodato.service';
import { PartnercteService } from '../servicios/partnercte.service';
import {LocalStorageService} from 'ngx-webstorage';
import { PeticionesService } from '../servicios/httpservice';
import { MatSidenav } from '@angular/material/sidenav';
import { Router,NavigationEnd } from '@angular/router'; 
import { DataDBService } from '../servicios/data-db.service';
import { EcommerceCarrService } from '../servicios/ecommerce-carr.service';
import {AccesosServiceService}from '../servicios/accesos-service.service'
import { Subscription } from 'rxjs';
import { ScrollService } from '../servicios/scroll.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';


/*
  Initialize the search client
  
  If you're logged into the Algolia dashboard, the following values for
  undefined and undefined are auto-selected from
  the currently selected Algolia application.
*/
 
 
// Replace INDEX_NAME with the name of your index.
 

declare var bootstrap: any; 

@Component({
  selector: 'app-newmenu', 
  templateUrl: './newmenu.component.html',
  styleUrls: ['./newmenu.component.css'],
  encapsulation: ViewEncapsulation.None 
})

export class NewmenuComponent implements OnInit, AfterViewInit, OnDestroy {


  private unsubscribe$ = new Subject<void>();
 
  @ViewChild('drawer') drawer: MatSidenav; 
  private cartSubscription: Subscription;
  public   isDropdownOpen = false;

/*   toggleDropdown(event: Event) {
    event.stopPropagation(); 
    this.isDropdownOpen = !this.isDropdownOpen;
  }
  @HostListener('document:click', ['$event'])
  closeDropdown(event: Event) {
    this.isDropdownOpen = false;
  } */
  
  public objSucursal_envio_partner:any;
  public objEnvio_partner:any ={strTitulo:''};
  public strAlmacen_partner:string;
  public strSucursal_partner:string;
 
  public strSucSeleccionada:string =""; 
  public strNombre_entrega_partner:string='';
  public btnEnvio:boolean =false ;
  public btnPickup:boolean =true;
  public hovCarPartner:boolean =false;
  public arrayDireccion_partner:any=[];
  public arraySucursal_partner:any=[];
  public acceso: any = 0
  public arrayAccesos: any; 
  public arrayAccesoSubMenu: any; 
  public arrayAccesosMenu: any;
  public lenguaje:any="";
  public strUsuario: any;
  public arrayArticulos: any[] = [];
  public openCart: boolean = false;
  public totalCarrito: number = 0;
  public isHovered:boolean=false;
  public modelEntrega_sucursal:any;
  public modelEntrga_direccion:any;
  @ViewChild('idetiqueta') idetiqueta!: ElementRef; 
  @ViewChild('btnCanvas') btnCanvas!:ElementRef;
  @ViewChild('btnCanvas2') btnCanvas2!:ElementRef;
  @ViewChild('scrollContainer') scrollContainer!: ElementRef;
private _dropdowns: any[] = [];
private _routerSub: any;

  public articulos$: Observable<any>;
  public articulosCotizador$: Observable<any>;
  public strArticulo: string = '';
  public strCliente: string = '';
  public strNombre:string;
  public strUsuarioInt:string="";
  mostrarComodatosSubMenu = false;
  public objMix1:boolean=false;
  public planeador:boolean=false;
  public compras:boolean=false;
  public spresupuesto:boolean=false;
  public rh:boolean=false;
  public reportes1:boolean=false;
  public ventas1:boolean=false;
  public partnerCuenta:boolean=false;
  public partnerComprar:boolean=false;
  public partnerCot:boolean=false;
  public partnerMisCot:boolean=false;
  public partnerPedidos:boolean=false;
  public partnerRecompesas:boolean=false;
  public leads1:boolean=false;
  public ruber:boolean = false;
  public aromia1:boolean = false;
  public directorio :boolean = false;
  public otros1:boolean = false;
  public ecomerce:boolean = false;
  public itemsCotizador:number = 0;
  public itemsCotizador_partner:number = 0;
  public itemsCotizador_partner_cot:number=0;
  public hovCar:boolean = false;
  public hovCarCm:boolean = false;
  public arrayCarritoArts:any;
  public arrayCarritoArtsCmdts:any;
  public dblSubTotal:number = 0 ;
  public strTipoUser:string = "";
  public altoEtiqueta: number = 0;
  public dblSubTotalCmdts:number = 0 ;
  public objCliente:any = {
    strCliente:"",
    strNombre:"",
    strDireccion:"",
    ClienteSeleccionado:false,
    strSucursal:"",
    NombreSucursal:"",
    tipoSucursal:""
  };
  public objClienteCmdts:any = {
    strCliente:"",
    strNombre:"",
    strDireccion:"",
    ClienteSeleccionado:false,
    strSucursal:"",
    NombreSucursal:"",
    tipoSucursal:""
  };
  public ctePartner:any = {};
  public strNumCte:string;
  public strNumCteCmdts:string;
  public strNombreCliente:string="";
  public strNombreSucursal:string="";
  public intTotalItems:number;
  public strSucursal:string="";
  public cteSelect:boolean=false; 
  public strArticuloTienda:string="";
  public strBuscar:string;
  public totalArtTienda:number=0;
  public objFamilia:any;
  public cartItems:any =[];
  public flagMenuCte:boolean=false
  public userData_tienda:any=[];
  public isSidenavOpened = false;
  public arrayCategorias:any=[];
  public tipoUsuario:any;
  public tagName:string='';
  public btnQuitarCte:boolean=false;
  public btnBarra_busqueda: boolean=false;
  public btnCarrito:boolean=false;
  public btnComodato:boolean=false;
  public objPartner_direccionEnvio:any={}
  public btnCarrito_partner: boolean =false;
  public strOpcion_envio_partner:string='Pick Up'
  public strTitulo_Canva_Partner:string='Seleccione Sucursal';
  public strConexion:string  ='';
  public    instantsearch: any;

  public searchText = '';
  public arraySugerencias: string[] = ['Pollo orgánico', 'Atún en agua', 'Aceite de oliva', 'Tostadas Saníssimas'];
  public filteredSugerencias: any = [];

  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset).pipe(map(result => result.matches),shareReplay());

  constructor( private zone: NgZone,private servicioPartner:PartnercteService,
    private scrollService: ScrollService,
    elem:ElementRef,
    public _serviciosService: PeticionesService,
    private ServAccesos:AccesosServiceService ,
    private cartService: EcommerceCarrService,
     private indexedDBService: DataDBService,private servPlantilla:PlantillafinService,
    private breakpointObserver: BreakpointObserver,  private carroservice:CarroService,
    private _carro: CarritoNService,  private localSt:LocalStorageService, private router: Router,private commodatoservice:ComodatoService ) {
 
   this.tagName=elem.nativeElement.tagName.toLowerCase();

 
  }

  ngOnInit(): void {  
//inicio de servicios para menu7
  this.indexedDBService.finBusqueda_Articulo_$
  .pipe(takeUntil(this.unsubscribe$))
  .subscribe((nuevoValor) => {
    this.strBuscar=nuevoValor;
  });
  this.indexedDBService.usuario_$
  .pipe(takeUntil(this.unsubscribe$))
  .subscribe((nuevoValor) => {
  this.strUsuario=nuevoValor?nuevoValor==0?'':nuevoValor  :'';
  this.strNombre=this.localSt.retrieve('strNombre')?this.localSt.retrieve('strNombre'):'';   

      if(this.strUsuario && this.strUsuario !='')
      {
         
          
      }
  });

this.indexedDBService.arrayAccesos_$
.pipe(takeUntil(this.unsubscribe$))
.subscribe((nuevoValor) => {
this.arrayAccesos=nuevoValor?nuevoValor:[];
console.log(this.arrayAccesos);
this.acceso = nuevoValor[0]?.strTipoAcceso;
var objAcceso = this.arrayAccesos.filter((o:any)=>o.strComponente == this.tagName);

this.btnQuitarCte= objAcceso.find((o: any) => o.strAccion == 'btnQuitar') ? true : false;  
this.btnBarra_busqueda =  objAcceso.find((o: any) => o.strAccion == 'btnBarra') ? true : false;  
this.btnCarrito=  objAcceso.find((o: any) => o.strAccion == 'btnCarrito') ? true : false;  
this.btnComodato=  objAcceso.find((o: any) => o.strAccion == 'btnComodato') ? true : false; 
this.btnCarrito_partner=  objAcceso.find((o: any) => o.strAccion == 'btnCarrito_Partner') ? true : false;   
if(this.acceso ==1015){
    this.servicioPartner.cteSeleccionado$.subscribe(valor => {
      this.ctePartner = valor;
        //console.log('Recibido en Componente B:', this.ctePartner);
    });
    /*if( !this.arrayAccesos[0].detalle_envio_partner ) { // si no hay ninguna direccion seleccionada, poner pikup por default con el alamcen del cliente
      this.fnGetSucursales_partner_inicio();
    }
    else {
      this.fnBuscarSucursal_partner();
      //this.fnGetDireccion_partner();
    }*/

     //obtenemos la direccion guardada en sesion 
    let objC =localStorage.getItem('objEnvio_partner'); 
    this.objEnvio_partner = objC  ? JSON.parse(objC) : {} ; //convertimos a json el objeto guardado en sesion
    //OBTENEMOS LO QUE HAYA EN ACCESOS
    this.strAlmacen_partner = (this.arrayAccesos && this.arrayAccesos[0]) ?this.arrayAccesos[0].strAlmacen :'1';
    this.strSucursal_partner= (this.arrayAccesos && this.arrayAccesos[0]) ?this.arrayAccesos[0].sucursal :'0';
    //REDIRIGIMOS SEGUN APLIQUE EL CASO
    if(this.objEnvio_partner && this.objEnvio_partner.strTipoDireccion=='direccion' ){
     // this.btnPickup=true;
      this.btnEnvio=false;
       this.toggleEnvio({}); 
      //this.fnGetDireccion_partner();
    }
    else { //si no es tipo direccion, nos vamos por default a las sucursales de entrega
      this.btnPickup=false;
      this.togglePickUP({});
      //this.fnGetSucursales_partner();
    }
  
  }

});

this.indexedDBService.arrayAccesosMenu_$
.pipe(takeUntil(this.unsubscribe$))
.subscribe((nuevoValor) => {  
  this.arrayAccesosMenu = nuevoValor?nuevoValor:[];
  console.log(this.arrayAccesosMenu)
});

this.indexedDBService.arrayAccesoSubMenu_$
.pipe(takeUntil(this.unsubscribe$))
.subscribe((nuevoValor) => {  
  this.arrayAccesoSubMenu= nuevoValor?nuevoValor:[];
}); 

this.indexedDBService.strConexion_$
.pipe(takeUntil(this.unsubscribe$))
.subscribe((nuevoValor) => { 
   this.strConexion = nuevoValor;
});


  this.indexedDBService.arraySucursales_partner_$
  .pipe(takeUntil(this.unsubscribe$))
  .subscribe((nuevoValor) => {
    //console.log('se selecciono una sucursal') 
      this.acceso = nuevoValor[0]?.strTipoAcceso;
      //funciones que se ejecutan solo para partners
      //actualizamos el store en la base de datos
      this.indexedDBService.setItem('arrayResult',   nuevoValor );
  });


// ----fin de menu--------


    document.addEventListener('click', (event: any) => {
      const offcanvasElement = document.querySelector('.offcanvas.show');
      if (offcanvasElement && !offcanvasElement.contains(event.target)) { 
        this.btnCanvas.nativeElement.click()
        this.btnCanvas2.nativeElement.click()
      }
    });
    this.fnGetCategorias();
    this.loadCart();

    this.commodatoservice.intTotalItems_C$
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe((nuevoValor) => {
      this.intTotalItems = nuevoValor;
    });
    this.commodatoservice.arrayItems_C$
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe((nuevoValor) => {
      this.arrayCarritoArtsCmdts = nuevoValor;
    });
    this.commodatoservice.dblSubTotalItems_C$
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe((nuevoValor) => {
      this.dblSubTotalCmdts = nuevoValor;
    });

    this.commodatoservice.ObjCliente_C$
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe((nuevoValor) => {
      this.objClienteCmdts = nuevoValor;
      if(nuevoValor.strCliente){
        this.strNumCteCmdts=nuevoValor.strCliente; 
        this.strNombreCliente=nuevoValor.strNombre;
        this.strSucursal =nuevoValor.intIDSucursal;
        this.strNombreSucursal=nuevoValor.strNombreSucursal;
        this.cteSelect = true;
      }
    });

    this.carroservice.intTotalItems$
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe((nuevoValor) => {
      this.itemsCotizador = nuevoValor;
    });
    /**carrito partner */
    this.carroservice.intTotalItems_Partner$
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe((nuevoValor) => {
      this.itemsCotizador_partner = nuevoValor;
    });
    /**cotizador partner */
    this.carroservice.intTotalItems_Partner_Cot$
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe((nuevoValor) => {
      this.itemsCotizador_partner_cot = nuevoValor;
    });
    this.carroservice.arrayItems$
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe((nuevoValor) => {
      this.arrayCarritoArts = nuevoValor;
    });

    this.carroservice.dblSubTotalItems$
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe((nuevoValor) => {
      this.dblSubTotal = nuevoValor;
    });

    this.carroservice.ObjCliente$
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe((nuevoValor) => {
      this.objCliente = nuevoValor;
      if(nuevoValor.ClienteSeleccionado){
        this.strNumCte=nuevoValor.strCliente;
      }else{
        this.strNumCte = ""
      }
    });
    //obj familia
    this.carroservice.ObjFamilia$
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe((nuevoValor) => {
      this.objFamilia = nuevoValor && nuevoValor.strFamilia && nuevoValor.strFamilia? nuevoValor :null;
    });

    
  }






  ngAfterViewInit(): void {
    setTimeout(() => {
      if (this.idetiqueta) {
        this.altoEtiqueta = this.idetiqueta.nativeElement.offsetHeight + 14;
      }
    }, 700);
    if (this.scrollContainer) {
      this.scrollService.setScrollContainer(this.scrollContainer);
    }

  }

 //---funciones de busqueda en meili
 filterSugerencias() {
    
  this.filteredSugerencias =[];
    if(this.searchText !=''){
      this._serviciosService.getMailiSearch(this.searchText, 15)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
      result => {
          this.filteredSugerencias = result?result.hits:[];
      });
    }
  } 

  seleccionarSugerencia(sugerencia: string) {
    this.searchText = sugerencia;
    this.filteredSugerencias = [];
  }

 
  //-----------fin libreria busqueda----------------------
  fnCloseTienda(){
    this.cartService.deleteLogin();
    this.router.navigate(['/tienda'])
  }

  loadCart() {
      // Suscribirse al carrito para recibir actualizaciones
      this.cartSubscription = this.cartService.getCartItems()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((items) => { 
        let items_arr = items;
        this.fnSumasItems(items_arr);
      });
    this.cartService.getUsr()
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(data => {
        this.userData_tienda = data?data:[]; // Actualizamos la variable cuando los datos cambian
 
    });
  }
  fnSumasItems(items_arr:any){
    this.cartItems =0;
    items_arr.forEach(art => {
      this.cartItems = this.cartItems + art.dblCantidad  
    });
   
   }
  
  fnIraFamilia(){
       //guardamos en el servicio de indexed db la ruta
       let objRuta_Anterior={
        ruta_origen:'/leads/directorio',
        ruta_destino:'/leads/detalleLeadFamilia',
        nombre:'Directorio'
      }
      console.log('---remove item desde irFamilias')
      this.indexedDBService.removeItem('objRuta_Anterior');
      this.indexedDBService.setItem('objRuta_Anterior',   objRuta_Anterior );
      this.carroservice.setFamilia({ idFamilia: this.objFamilia.idFamilia, strFamilia: this.objFamilia.strFamilia, strClienteSeleccionado:'', strNombreCliente:''})
      this.router.navigate(['/leads/detalleLeadFamilia'], {
      queryParams: { idFamilia: this.objFamilia.idFamilia, strFamilia: this.objFamilia.strFamilia }
    });
  }
  fnReportesAdministrativos() {
    //this.iframeVisible = true;
    /* const url = "https://ecodelinegocio.com/Intranet/catalogoDigital/"+this.strFamilia; */
    const url = `https://www.ecodelinegocio.com/Intranet/catalogoDigital/${this.strCliente}/${'""'}`;
    //this.urlIframe = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
  fnBuscar() {
    if (this.strBuscar && this.strBuscar.trim() !== "") {
      this.indexedDBService.fnIniciaBusqueda_Articulo(this.strBuscar)
    } else {
      const input = document.getElementById('inputBuscar');
      if (input) {
        input.setAttribute('data-bs-toggle', 'tooltip');
        input.setAttribute('data-bs-placement', 'top');
        input.setAttribute('title', 'Debe ingresar un articulo o caracteristica para buscar');

        const tooltip = new bootstrap.Tooltip(input);

        this.strBuscar= "";
        tooltip.show();
        setTimeout(() => {
          tooltip.dispose();
        }, 2000);
      }
    }

  }
  toggleComodatosSubMenu(): void {
    this.mostrarComodatosSubMenu = !this.mostrarComodatosSubMenu;
  }
  fnGetArticulo() {
    this.totalCarrito = this._carro.getTotal();
    this.articulos$ = this._carro.getTotalArticulos$();
    this.articulos$
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(n =>
    this.totalCarrito = n); 
  }

  toggleDrawer() {
    this.drawer.toggle();
  }
  fnGetCategorias(){
    let objenv = {
      strAccion: 'getCategorias',
      strConexion: "COMERCIAL"
    }
    this._serviciosService.mostrarCotizaciones(objenv, 'sp_ECommerce')
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(
      result => {
        this.arrayCategorias = result
      
        this.arrayCategorias.forEach(cat => {
          cat.seeHov = false;
          cat.imagen = cat.strCategoria =="ALMACENAMIENTO Y ORGANIZACION" ?"./assets/categorias_ecommerce/ALMACENAMIENTO Y ORGANIZACION.jpg":
          cat.strCategoria =="AMENIDADES"?"./assets/categorias_ecommerce/AMENIDADES.jpg":
          cat.strCategoria =="ARTICULOS DE LIMPIEZA"?"./assets/categorias_ecommerce/ARTICULOS DE LIMPIEZA.jpg":
          cat.strCategoria =="BOLSA PARA BASURA"?"./assets/categorias_ecommerce/BOLSA PARA BASURA.jpg":
          cat.strCategoria =="BOTES Y CONTENEDORES"?"./assets/categorias_ecommerce/BOTES Y CONTENEDORES.jpg":
          cat.strCategoria =="CARROS UTILITARIOS"?"./assets/categorias_ecommerce/CARROS UTILITARIOS.jpg":
          cat.strCategoria =="COMPLEMENTOS PARA BAÑO"?"./assets/categorias_ecommerce/COMPLEMENTOS PARA BAÑO.jpg":
          cat.strCategoria =="CONTROL DE AROMAS"?"./assets/categorias_ecommerce/CONTROL DE AROMAS.jpg":
          cat.strCategoria =="DESECHABLES Y BIODEGRADABLES"?"./assets/categorias_ecommerce/DESECHABLES Y BIODEGRADABLES.jpg":
          cat.strCategoria =="EQUIPO DE PROTECCION"?"./assets/categorias_ecommerce/EQUIPO DE PROTECCION.jpg":
          cat.strCategoria =="EQUIPOS Y MAQUINAS DE LIMPIEZA INDUSTRIAL"?"./assets/categorias_ecommerce/EQUIPOS Y MAQUINAS DE LIMPIEZA INDUSTRIAL.jpg":
          cat.strCategoria =="HIGIENE Y CUIDADO PARA MANOS"?"./assets/categorias_ecommerce/HIGIENE Y CUIDADO PARA MANOS.jpg":
          cat.strCategoria =="MICROFIBRA"?"./assets/categorias_ecommerce/MICROFIBRA.jpg":
          cat.strCategoria =="PAPEL Y DESPACHADORES"?"./assets/categorias_ecommerce/PAPEL Y DESPACHADORES.jpg":
          cat.strCategoria =="QUIMICOS PARA LIMPIEZA"?"./assets/categorias_ecommerce/QUIMICOS PARA LIMPIEZA.jpg":
          cat.strCategoria =="QUIMICOS PARA MANTENIMIENTO"?"./assets/categorias_ecommerce/QUIMICOS PARA MANTENIMIENTO.jpg":
          cat.strCategoria =="TAPETES"?"./assets/categorias_ecommerce/TAPETES.jpg":
          cat.strCategoria =="UTENSILIOS DE COCINA"?"./assets/categorias_ecommerce/UTENSILIOS DE COCINA.jpg":
          cat.strCategoria =="WIPERS Y TOALLAS HUMEDAS"?"./assets/categorias_ecommerce/WIPERS Y TOALLAS HUMEDAS.jpg":"./assets/categorias_ecommerce/NO_DISPONIBLE.jpg"
        });
      })
  }

  fnCerrarSesion(){

  if (this.drawer.opened) {
    this.drawer.close().then(() => {
      setTimeout(() => {
        this.fnquitarCliente();
        this.fnquitarFamilia();
        this.fncerrar()
      }, 1); // 100 ms de retraso
    });
  } else {
    this.fnquitarCliente();
    this.fnquitarFamilia();
    this.fncerrar()
    this.fnquitarClientePartner();
  }

  }
 
  fncerrar(){
    let objPlantilla = {boolActive:false, intIDMovimientoVenta:0};
    this.objCliente = {};
    this.carroservice.setCte(this.objCliente);
    this.carroservice.deleteCarrito();
    this.servPlantilla.setPlantilla(objPlantilla);
    this.localSt.clear();
    localStorage.clear();
    this.commodatoservice.setCte({});
    this.commodatoservice.deleteCarrito();
    this.localSt.store('arrayAccesosMenu',[]);
    this.localSt.store('arrayAccesos',[]);
    this.localSt.store('arrayAccesosMenuCte',[]);
    this.localSt.store('arrayAccesoSubMenu', []);
    this.localSt.store('ObjPlantillaEdit', {});
    this.localSt.store('arrayItemsComodato', []);
    this.localSt.store('ObjClienteComodato', []);
    this.localSt.store('arrayCotizador', []);
    this.localSt.store('arrayTotalesPrecio', []);
    this.localSt.store('arrayArticulos', []);
    this.localSt.store('dblTotal', 0);
    this.localSt.store('cteParner', {});
    this.localSt.store('array_Agentes',[]);
    this.localSt.store('array_Sucursales', []);
    this.localSt.store('array_Gerentes', []);  
    this.ServAccesos.updateAccesos([]);
    this.carroservice.setModoPlantilla(false);
    console.log('borrar carrito desde fncerrar')
     this.fnBorrarCarrito()
    this.fnquitarCliente();
    if(this.acceso == '1015' ){
      this.router.navigate(['/partner','login-partner']);
    }else{this.router.navigate(['/tiendaproducto/login']);}
    
  }
  

  ngOnDestroy(){
    console.log('borrar carrito en ngondestroy')
    this.unsubscribe$.next();
    this.unsubscribe$.complete();

    this.drawer.close();
 
    //this.fnBorrarCarrito()
   
   
  }

  fnBorrarCarrito(){
    console.log('--remove item, desde borrar carrito---')
       let objPlantilla = {boolActive:false, intIDMovimientoVenta:0}
    this.objCliente = {};
    this.carroservice.setCte(this.objCliente);
    this.carroservice.deleteCarrito();
    this.servPlantilla.setPlantilla(objPlantilla); 
    this.indexedDBService.removeItem('arrayResult');
     this.ServAccesos.updateAccesos([]);
    this.carroservice.setModoPlantilla(false);
    //this.fnCerrarSesion(); 
   
     this.fnquitarClientePartner();
 
    this.localSt.clear();
    this.commodatoservice.setCte({});
    this.commodatoservice.deleteCarrito();
    this.localSt.store('arrayAccesosMenu',[]);
    this.localSt.store('arrayAccesos',[]);
    this.localSt.store('arrayAccesoSubMenu', []);
    this.localSt.store('ObjPlantillaEdit', {});
    this.localSt.store('arrayItemsComodato', []);
    this.localSt.store('ObjClienteComodato', []);
    this.localSt.store('arrayCotizador', []);
    this.localSt.store('arrayTotalesPrecio', []);
    this.localSt.store('arrayArticulos', []);
    this.localSt.store('dblTotal', 0);
    this.localSt.store('array_Agentes', []);
    this.localSt.store('array_Sucursales', []);
    this.localSt.store('array_Gerentes', []);
    this.fnGetArticulo();  
 }

  fnShowCarrito() {
  }
  
  fnquitarCliente(){ 
    this.strNumCte =""
    this.objCliente = {};
    let objPlantilla = { boolActive: false, intIDMovimientoVenta: 0 }
    this.servPlantilla.setPlantilla(objPlantilla);
    this.carroservice.setCte({});
    this.carroservice.setModoPlantilla(false);
    this.carroservice.deleteCarrito();
  }
  fnquitarFamilia(){
    this.carroservice.setFamilia(null);
  }

  toggleSidenav() {
    this.isSidenavOpened = !this.isSidenavOpened;
    this.drawer.toggle();
  }
  fnDetalleCte(){
        //guardamos en el servicio de indexed db la ruta
        let objRuta_Anterior={
          ruta_origen:'/leads/directorio',
          ruta_destino:'/leads/detalleLeadCliente',
          nombre:'Directorio'
        }
        console.log('----RemoveItem desde Detalle cte---')
        this.indexedDBService.removeItem('objRuta_Anterior');
        this.indexedDBService.setItem('objRuta_Anterior',objRuta_Anterior);
        //agregamos a carrito el cliente
      this.router.navigate(['/leads/detalleLeadCliente'],{queryParams:{strCliente: this.strNumCte}});
  }

  fnBuscarArtTienda() {
    /*this.router.navigate(['/tienda-sub-categoria'], {
      queryParams: { tipoBusqueda: 'artTienda', strArticulo: this.strArticuloTienda,strLinea:"RESULTADOS DE LA BÚSQUEDA",subLinea:"" },
      queryParamsHandling: 'merge' // Esto combina los nuevos parámetros con los existentes
    });*/

    const url = ['/tienda', this.slugify(this.strArticuloTienda),this.slugify(this.strArticuloTienda)  ]; // Sin .html, sin skuid
        this.router.navigate(url,{ queryParams: { s: this.strArticuloTienda }} ); // Con parámetros de consulta

    this.strArticuloTienda = ""
    this.btnCanvas.nativeElement.click();
  }
 slugify(text: string): string {
        // Función para crear slugs (ajusta según tus necesidades)
        if (!text) return '';
        return text
            .toLowerCase()
            .replace(/[^a-z0-9 -]/g, '') // Remueve caracteres inválidos
            .replace(/\s+/g, '-')       // Reemplaza espacios con guiones
            .replace(/-+/g, '-');       // Remueve guiones duplicados
    }
  fnIrSubLinea(obj:any){  
    // Componente de origen
  /*   this.router.navigate(['/tienda-categoria'], { 
      queryParams: { strCategoria: obj.strCategoria }
  }); */



       localStorage.setItem('strCategoria_ecommerce',obj.strCategoria);


  this.router.navigate(['/tienda',this.slugify(obj.strCategoria)], { 
    queryParams: { strCategoria: obj.strCategoria }
  }).then(() => {
    // Forzar un reload de la página
    window.location.reload();
  });
  }

  
  
  fnNav(nav:string){
    this.router.navigate(['/tiendaproducto'], { 
      queryParams: { strTipo: nav }
    }).then(() => {
      // Forzar un reload de la página
      window.location.reload();
    });
   
}


fnIrHome(){
  this.router.navigate(['/'+this.arrayAccesos[0].strUrlHome+''])
}

/**partner */
toggleEnvio(event:any) {
  this.btnEnvio = !this.btnEnvio;
  this.btnPickup = this.btnEnvio == true ? false : this.btnPickup;
  this.strOpcion_envio_partner = this.btnEnvio == true ? 'Envío Estándar':'Pick Up';
  this.strTitulo_Canva_Partner =  this.btnEnvio == true ? 'Seleccione su dirección':'Seleccione Sucursal';
   let objC =localStorage.getItem('objEnvio_partner'); 
  let algo =JSON.parse(objC)
  this.objEnvio_partner = algo && algo.strTipoDireccion =='direccion' ? algo : {} ;
  this.fnGetDireccion_partner();
   
}
togglePickUP(event:any) {
 // this.objEnvio_partner.strTitulo =  this.arrayAccesos[0].nombre_envioPartner 

  this.btnPickup = !this.btnPickup;
  this.btnEnvio = this.btnPickup == true ? false : this.btnEnvio;
  this.strOpcion_envio_partner = this.btnPickup == true ? 'Pick Up': 'Envío Estándar';
  this.strTitulo_Canva_Partner =  this.btnPickup == true ?  'Seleccione Sucursal': 'Seleccione su dirección';

  let objC =localStorage.getItem('objEnvio_partner'); 
  let algo =JSON.parse(objC)
  this.objEnvio_partner = algo && algo.strTipoDireccion =='sucursal' ? algo : {} ; 
  this.fnGetSucursales_partner();
}
fnGetDireccion_partner(){
  this.arrayDireccion_partner = []; 
  let objenv = {
    strAccion: 'getListado_sucursales_CTE',
    strConexion: "COMERCIAL",
     strCliente: this.strNumCte
  } 
  this._serviciosService.mostrarCotizaciones(objenv, 'sp_ModVentas_Leads')
  .pipe(takeUntil(this.unsubscribe$))
  .subscribe(
    result => {
      console.log(result);
      this.arrayDireccion_partner = result  ; //cuando entra aqui es porque el usuario previamente selcciono una direccion de entrega

      //inicializamos el model del select  
      let objEnvio_sesion= this.arrayDireccion_partner.find(o=>o.strAlmacen == this.strAlmacen_partner && o.strSucursal == this.strSucursal_partner ) ; 
      this.modelEntrga_direccion = objEnvio_sesion ? objEnvio_sesion:this.arrayDireccion_partner[0];
      if(!this.arrayAccesos[0].detalle_envio_partner){
          this.fnSelecciona_sucursal_Partner(this.objEnvio_partner,'ENVIO') //si todavía no existe, ponemos el primero
      } 

 

      }
   )
}
 
fnGetSucursales_partner(){
  this.arraySucursal_partner =[];
  let objenv = {
    strAccion: 'getSucursales',
    strConexion: "COMERCIAL" 
  } 

  this._serviciosService.mostrarCotizaciones(objenv, 'sp_ECommerce')
  .pipe(takeUntil(this.unsubscribe$))
  .subscribe(
    result => {
      console.log(result)
          this.arraySucursal_partner = result;
        
          let objC =localStorage.getItem('objEnvio_partner'); 
          let objEnvio= this.arraySucursal_partner.find(o=>o.strAlmacen == this.strAlmacen_partner && o.strSucursal == this.strSucursal_partner ) ;
          objEnvio.strTitulo =this.objEnvio_partner && this.objEnvio_partner.strNombre?this.objEnvio_partner.strNombre:"" ; 
          
          //en caso de que no haya en sesion ninguna sucursal seleccionada, inicializamos objEnvio_partner con la por default
           let algo= JSON.parse(objC)
           //this.objEnvio_partner = objC  ? algo : objEnvio ; //convertimos a json el objeto guardado en sesion
            if(!algo){
              this.selecciona_sucursal(objEnvio)
            }
           let objEnvio_usuario= this.arraySucursal_partner.find(o=>o.strAlmacen == this.strAlmacen_partner && o.strSucursal == this.strSucursal_partner ) ;
           let objEnvio_sesion= this.arraySucursal_partner.find(o=>o.strAlmacen == this.objEnvio_partner.strAlmacen && o.strSucursal == this.objEnvio_partner.strSucursal ) ; 

          
          //inicializamos el model del select
           this.modelEntrega_sucursal = this.objEnvio_partner.strTipoDireccion=='sucursal'?objEnvio_sesion:objEnvio_usuario;
           if(!this.arrayAccesos[0].detalle_envio_partner){
            this.fnSelecciona_sucursal_Partner(this.objEnvio_partner,'PICKUP') //si todavía no existe, ponemos el primero
           } 
      }
   )
}
 
//---------------------------------------------------------------------------------------------------------------------------------------------------------
  fnBuscarSucursal_partner(){  
    let tipo_envio_partner = (this.arrayAccesos && this.arrayAccesos[0] && this.arrayAccesos[0].strTipo_envio_partner) ?this.arrayAccesos[0].strTipo_envio_partner :'PICKUP';
   
    if(tipo_envio_partner == 'PICKUP'){
      this.btnEnvio=false
      this.btnPickup = true;
      this.strAlmacen_partner = (this.arrayAccesos && this.arrayAccesos[0]) ?this.arrayAccesos[0].strAlmacen :'1'; 
      this.strSucursal_partner = (this.arrayAccesos && this.arrayAccesos[0]) ?this.arrayAccesos[0].strSucursal :'0'; 
      this.fnGetSucursales_partner(); 
      
    }
    else {
      this.btnEnvio=true
      this.btnPickup = false; 
      this.strAlmacen_partner = (this.arrayAccesos && this.arrayAccesos[0]) ?this.arrayAccesos[0].strAlmacen :'1'; 
      this.strSucursal_partner = (this.arrayAccesos && this.arrayAccesos[0]) ?this.arrayAccesos[0].strSucursal :'0'; 
      this.strOpcion_envio_partner='Envío Estándar'
      this.fnGetDireccion_partner();
    
    }
    
    
  }
  fnSelecciona_sucursal_Partner (objSuc:any, tipo:string){
   
   /* if(tipo == "PICKUP"){*/
      let nombre = tipo=='PICKUP'?objSuc.strNombre:objSuc.strSucursal;
      let almacen =  tipo=='PICKUP'?objSuc.strAlmacen: objSuc.strAlmacen;
      let codigoPostal = objSuc.strCodigoPostal;
      let sucursal = objSuc.strSucursal;

      
    
      //let objEnvioSelecionado = {tipo:tipo, strNombre:nombre, strAlmacen :almacen, strCodigoPostal:codigoPostal};
      if(tipo =="PICKUP"){
        /*this.objEnvio_partner = this.arraySucursal_partner.find(o=>o.strNombre == objSuc.strNombre && o.strSucursal == objSuc.strSucursal);
        this.objEnvio_partner.strTitulo = objSuc.strNombre;*/
        /*this.arraySucursal_partner.forEach(suc => {
          if(this.objEnvio_partner.strSucursal == suc.strSucursal && this.objEnvio_partner.strNombre == suc.strNombre){
            suc.selected_partner = true
          }else{
            suc.selected_partner = false
          }
        });*/
      }else{
       /* let objDetalleenvio_partner =this.arrayAccesos[0].detalle_envio_partner ? this.arrayAccesos[0].detalle_envio_partner:{};
        this.objEnvio_partner = this.arrayDireccion_partner.find(o=>o.intId_Direccion == objDetalleenvio_partner.intId_Direccion  ) ? this.arrayDireccion_partner.find(o=>o.intId_Direccion == objDetalleenvio_partner.intId_Direccion  ):this.arrayDireccion_partner[0];
        this.objEnvio_partner.strTitulo = objDetalleenvio_partner.strSucursal;*/

/*
        this.arrayDireccion_partner.forEach(suc => {
          if(this.objEnvio_partner.intId_Direccion == suc.intId_Direccion){
            suc.selected_partner = true
          }else{
            suc.selected_partner = false
          }
        });*/
      }
       //actualizamos el almacen para todos los accesos, ejecutamos el servicio
       this.arrayAccesos.forEach(element => {
        element.sucursal=sucursal;
        element.strSucursal = sucursal;
        element.strAlmacen =almacen;
        element.strTipo_envio_partner = tipo;
        element.strCodigoPostal = codigoPostal;
        element.nombre_envioPartner = nombre;
        objSuc.tipo_envio = tipo;
        element.detalle_envio_partner=objSuc;
       });
      this.indexedDBService.setItem('arrayResult_parnert',  this.arrayAccesos );
      //this.recargarComponenteActual();
  }


  //--------------codigo nuevo partner ---------------------------
  fnGetSucursales_partner_inicio(){
    this.arraySucursal_partner =[];
    let objenv = {
      strAccion: 'getSucursales',
      strConexion: "COMERCIAL" 
    } 
  
    this._serviciosService.mostrarCotizaciones(objenv, 'sp_ECommerce')
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(
      result => {
        this.arraySucursal_partner = result;
        /*this.arraySucursal_partner.forEach(suc => {
        suc.selected_partner = false
        });*/

        this.btnEnvio=false
        this.btnPickup = true;
        this.strAlmacen_partner = (this.arrayAccesos && this.arrayAccesos[0]) ?this.arrayAccesos[0].strAlmacen :'1';
        this.strSucursal_partner= (this.arrayAccesos && this.arrayAccesos[0]) ?this.arrayAccesos[0].sucursal :'0';
          
     
        this.objEnvio_partner = this.arraySucursal_partner.find(o=>o.strAlmacen == this.strAlmacen_partner && o.strSucursal == this.strSucursal_partner) ;
        this.objEnvio_partner.strTitulo =this.objEnvio_partner && this.objEnvio_partner.strNombre?this.objEnvio_partner.strNombre:"" ; 
      
      
        this.arraySucursal_partner.forEach(suc => {
          if(this.objEnvio_partner.strSucursal == suc.strSucursal && this.objEnvio_partner.strNombre == suc.strNombre){
            suc.selected_partner = true
          }else{
            suc.selected_partner = false
          }
        });  
        this.fnSelecciona_sucursal_Partner(this.objEnvio_partner,'PICKUP') 
        }
     )
  }
  fnquitarClientePartner(){
    this.servicioPartner.setCte({});
    this.ctePartner = {};

  }


  recargarComponenteActual() {
    const currentUrl = this.router.url;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigateByUrl(currentUrl);
    });
  }
  selecciona_sucursal(objSucursal:any){
    console.log(objSucursal);
    this.objEnvio_partner.strTitulo=objSucursal.strNombre? objSucursal.strNombre:'';
    this.objEnvio_partner.strCalle=objSucursal.strDireccion? objSucursal.strDireccion:''; 
    this.objEnvio_partner.strDireccion=objSucursal.strDireccion? objSucursal.strDireccion:''; 
    this.objEnvio_partner.strNo_exterior=objSucursal.strNumeroExterior? objSucursal.strNumeroExterior:''; 
    this.objEnvio_partner.strColonia=objSucursal.strColonia? objSucursal.strColonia:''; 
    this.objEnvio_partner.strDelegacion=objSucursal.strDelegacion? objSucursal.strDelegacion:''; 
    this.objEnvio_partner.strEstado=objSucursal.strEstado? objSucursal.strEstado:'';  
    this.objEnvio_partner.strCodigoPostal=objSucursal.strCodigoPostal? objSucursal.strCodigoPostal:''; 
    this.objEnvio_partner.strAlmacen=objSucursal.strAlmacen? objSucursal.strAlmacen:''; 
    this.objEnvio_partner.strSucursal=objSucursal.strSucursal? objSucursal.strSucursal:''; 
     this.objEnvio_partner.strContacto_Nombre= objSucursal.strContacto_Nombre? objSucursal.strContacto_Nombre:''; 
    this.objEnvio_partner.strContacto_Telefono=objSucursal.strContacto_Telefono? objSucursal.strContacto_Telefono:''; 
    this.objEnvio_partner.strNombre =objSucursal.strNombre? objSucursal.strNombre:''; 
    this.objEnvio_partner.strPoblacion =objSucursal.strPoblacion? objSucursal.strPoblacion:''; 
    this.objEnvio_partner.strTelefonos =objSucursal.strTelefonos? objSucursal.strTelefonos:'';
    this.objEnvio_partner.strTipoDireccion='sucursal';
    //guardamos la direccion seleccionada en sesion  
    localStorage.setItem('objEnvio_partner', JSON.stringify(this.objEnvio_partner));
    this.fnSelecciona_sucursal_Partner(this.objEnvio_partner,'PICKUP') 
 

  }
  selecciona_direccion(objDireccion:any){
    this.objEnvio_partner.strTitulo=objDireccion.strSucursalD? objDireccion.strSucursalD:'';
    this.objEnvio_partner.strCalle=objDireccion.strCalle? objDireccion.strCalle:''; 
    this.objEnvio_partner.strDireccion=objDireccion.strCalle? objDireccion.strCalle:''; 
    this.objEnvio_partner.strNo_exterior=objDireccion.strNo_exterior? objDireccion.strNo_exterior:''; 
    this.objEnvio_partner.strColonia=objDireccion.strColonia? objDireccion.strColonia:''; 
    this.objEnvio_partner.strDelegacion=objDireccion.strDelegacion? objDireccion.strDelegacion:''; 
    this.objEnvio_partner.strEstado=objDireccion.strEstado? objDireccion.strEstado:'';  
    this.objEnvio_partner.strCodigoPostal=objDireccion.strCodigoPostal? objDireccion.strCodigoPostal:''; 
    this.objEnvio_partner.strAlmacen=objDireccion.strAlmacen? objDireccion.strAlmacen:''; 
    this.objEnvio_partner.strSucursal=objDireccion.strSucursal? objDireccion.strSucursal:''; 
    this.objEnvio_partner.strContacto_Nombre= objDireccion.strContacto_Nombre? objDireccion.strContacto_Nombre:''; 
    this.objEnvio_partner.strContacto_Telefono=objDireccion.strContacto_Telefono? objDireccion.strContacto_Telefono:''; 
    this.objEnvio_partner.strNombre =objDireccion.strNombre? objDireccion.strNombre:''; 
    this.objEnvio_partner.strPoblacion =objDireccion.strPoblacion? objDireccion.strPoblacion:''; 
    this.objEnvio_partner.strTelefonos =objDireccion.strTelefonos? objDireccion.strTelefonos:'';
    this.objEnvio_partner.strTipoDireccion='direccion';

    //guardamos la direccion seleccionada en sesion  
    localStorage.setItem('objEnvio_partner', JSON.stringify(this.objEnvio_partner));
     this.fnSelecciona_sucursal_Partner(this.objEnvio_partner,'ENVIO') 
  }
}